export default __webpack_public_path__ + "static/media/222.af1d4878.jpg";